var _circle, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenFilledTickIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    fill: "#27AE60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57799 4.26856L4.77706 7.06949C4.72614 7.12042 4.67521 7.14588 4.59882 7.14588C4.52243 7.14588 4.47151 7.12042 4.42058 7.06949L3.14743 5.79634C3.04558 5.69449 3.04558 5.54171 3.14743 5.43986C3.24929 5.33801 3.40206 5.33801 3.50392 5.43986L4.59882 6.53477L7.22151 3.91208C7.32336 3.81023 7.47614 3.81023 7.57799 3.91208C7.67984 4.01393 7.67984 4.16671 7.57799 4.26856Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7348_46811",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 5,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57799 4.26856L4.77706 7.06949C4.72614 7.12042 4.67521 7.14588 4.59882 7.14588C4.52243 7.14588 4.47151 7.12042 4.42058 7.06949L3.14743 5.79634C3.04558 5.69449 3.04558 5.54171 3.14743 5.43986C3.24929 5.33801 3.40206 5.33801 3.50392 5.43986L4.59882 6.53477L7.22151 3.91208C7.32336 3.81023 7.47614 3.81023 7.57799 3.91208C7.67984 4.01393 7.67984 4.16671 7.57799 4.26856Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7348_46811)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30713 2.30786H8.41824V8.41897H2.30713V2.30786Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFilledTickIcon);
export default __webpack_public_path__ + "static/media/GreenFilledTickIcon.461aaa388198707cd03f67e6c7e98da9.svg";
export { ForwardRef as ReactComponent };